import { gateway } from "../../../gateway";

interface IDataResponse<T = unknown> {
  status: number;
  message: string;
  data?: T;
}

/** Soft-archive a quote so it stays hidden from default listings but preserves history. */
export const archiveQuote = async (quoteId: number): Promise<void> => {
  await gateway.patch<IDataResponse>(`/quotes/${quoteId}/archive`);
};

export const unarchiveQuote = async (quoteId: number): Promise<void> => {
  await gateway.patch<IDataResponse>(`/quotes/${quoteId}/unarchive`);
};

/**
 * Hard-delete a quote. Backend responds with 409 if the quote has invoices or jobs; callers
 * should fall back to archive in that case.
 */
export const deleteQuote = async (quoteId: number): Promise<void> => {
  await gateway.delete<IDataResponse>(`/quotes/${quoteId}`);
};
